// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1LFTh","card":"Cards_card__3Dtp1","infected":"Cards_infected__1nidB","recovered":"Cards_recovered__2GQRr","deaths":"Cards_deaths__KNoW3"};